












import {computed, defineComponent, PropType} from "@vue/composition-api";
import {ProjectEntityInterface} from "@tool/tool.types";
import ProjectReportsLayout from "@tool/Pages/App/Project/Reports/layout/ProjectReportsLayout.vue";
import {
    ClickStat,
    DateRangeInterface,
    ProjectReportSingleFilterInterface
} from "@tool/Pages/App/Project/Reports/reports.types";
import OverviewStatCard from "@tool/Pages/App/Project/Reports/partials/OverviewStatCard.vue";
import moment from "moment";
import ReportsOverviewChart from "@tool/Pages/App/Project/Reports/partials/ReportsOverviewChart.vue";

interface ReportsOverviewStats {
    total: number;
    most: {
        count: number;
        date: string;
    } | null;
    average: number;
}

export default defineComponent({
    components: {
        ReportsOverviewChart,
        ProjectReportsLayout,
        OverviewStatCard
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
        dateRange: {
            type: Object as PropType<DateRangeInterface<string>>,
            required: true
        },
        filters: {
            type: Array as PropType<ProjectReportSingleFilterInterface<any>[]>,
            required: true
        },
        stats: {
            type: Object as PropType<ReportsOverviewStats>,
            required: true
        },
        clicks: {
            type: Array as PropType<ClickStat[]>,
            required: true
        }
    },
    setup(props) {
        const mostClicksText = computed(() => {
            if (!props.stats.most) {
                return 'N/A';
            }

            return props.stats.most.count + ' (' + moment(props.stats.most.date).format('MMM Do') + ')';
        });

        const averageClicksText = computed(() => {
            if(props.stats.average > 0 && props.stats.average < 1) {
                return '< 1/day';
            }

            return `${props.stats.average}/day`
        })

        return {
            mostClicksText,
            averageClicksText
        }
    }
})
